let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jnlZ0")).then(() => parcelRequire('2sLjS'));